module.exports = __webpack_public_path__ + "media/images/xpass/landing_page/profile-screen-phone-21e214f5dac7bd46ac1722ee17a049b1.png";